import { useEffect, useState } from 'react'
import { useShallow } from 'zustand/react/shallow'

import { ActionsMenu } from '@/components/table/actions'
import { ActionAddQuarantine } from '@/components/table/actions/quarantine/ActionAddQuarantine'
import { ActionMergeQuarantineDialog } from '@/components/table/actions/quarantine/ActionOpenMergeQuarantineDialog'
import { FilterableTable } from '@/components/table/base'
import { TitleSetter } from '@/components/Title'
import { useQuarantinePlayers } from '@/stores/quarantinePlayers'

import {
  STANDARIZED_GOLF_PLAYERS_TABLE_COLUMNS,
  STANDARIZED_GOLF_PLAYERS_TABLE_FILTERS
} from '../standarizedGolfPlayer.table'

export const QuarantinePlayersTableView = () => {
  const { data, isLoading, isFetching, fetchData, resetState } = useQuarantinePlayers(
    useShallow((state) => ({
      data: state.data,
      isLoading: state.status === 'loading',
      isFetching: state.status === 'fetching',
      fetchData: state.fetchData,
      resetState: state.resetState
    }))
  )

  const [loading, setLoading] = useState(isLoading)

  useEffect(() => {
    setLoading(isLoading)
  }, [isLoading])

  useEffect(() => {
    fetchData()
    return resetState
  }, [])

  return (
    <>
      <TitleSetter title="Golf - Quarantine Players" />
      <FilterableTable
        columns={STANDARIZED_GOLF_PLAYERS_TABLE_COLUMNS}
        filters={STANDARIZED_GOLF_PLAYERS_TABLE_FILTERS}
        data={data}
        loading={loading}
        disableColumnVisibility
        fetching={isFetching}
        clientSideFilters
        clientSideSortAndPagination
        defaultSort={{
          attribute: 'id',
          order: 'asc'
        }}
        rowActions={
          <ActionsMenu>
            <ActionAddQuarantine displaySeparately setLoading={setLoading} onSubmit={fetchData} />
            <ActionMergeQuarantineDialog displaySeparately onSubmit={fetchData} />
          </ActionsMenu>
        }
      />
    </>
  )
}
